import {useCallback, useEffect, useState} from "react";
import Api from "../common/Api";
import {Spin, Tabs} from "antd";
import {embedDashboard} from "amazon-quicksight-embedding-sdk"

const {TabPane} = Tabs;

const QuickSight = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [dashboards, setDashboards] = useState<any>([]);

    useEffect(() => {
        (async () => {
            const {data} = await Api.quicksight.getEmbedURLs();
            setDashboards(data.embedURLs.slice(0, 2).map((url: string, key: number) => {
                return ({
                    url,
                    scrolling: "no",
                    height: "100%",
                    width: "100%",
                    footerPaddingEnabled: true,
                })
            }));
            setLoading(false);
        })();
    }, [])

    const onRefChange = useCallback((node: HTMLDivElement) => {
        if (node !== null) {
            embedDashboard({...dashboards[node.id], container: node})
        }
    }, [dashboards]);

    return (
        loading ? <div style={{height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}><Spin size="large"/></div> :
            <Tabs defaultActiveKey="0" style={{height: "100%"}}>
                {dashboards && dashboards.map((_: any, key: number) => {
                    return (
                        <TabPane style={{height: "100%"}} tab={`Dashboard ${key + 1}`} key={key}>
                            <div
                                id={key.toString()}
                                style={{height: "100%"}}
                                ref={onRefChange}>
                            </div>
                        </TabPane>
                    )
                })}
            </Tabs>
    )
}

export default QuickSight;
